module.exports = __webpack_public_path__ + "img/offer1.6a423af9.jpg";